import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let tx_card_id = useDataValue({
    context: 'tab',
    path: 'treatment_card_id',
    viewPath: props.viewPath,
  })
  return {
    variables: { tx_card_id },
    pause: !tx_card_id,
  }
}
